// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileCombinationPopup_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.FileCombinationPopup {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    width: 480px;
    max-width: 90%;
    overflow: hidden;
}

.FileCombinationPopup_header {
    background: #f8f9fa;
    padding: 16px 20px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.FileCombinationPopup_title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.FileCombinationPopup_close {
    background: none;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.FileCombinationPopup_close:hover {
    background-color: #e9ecef;
}

.FileCombinationPopup_content {
    padding: 24px 20px;
}

.FileCombinationPopup_question {
    font-size: 16px;
    color: #333;
    margin-bottom: 16px;
    line-height: 1.5;
}

.FileCombinationPopup_description {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    background: #f8f9fa;
    padding: 12px;
    border-radius: 4px;
    border-left: 4px solid #007bff;
}

.FileCombinationPopup_buttons {
    padding: 16px 20px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
}

.FileCombinationPopup_button {
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 80px;
}

.FileCombinationPopup_button--no {
    background: #6c757d;
    color: white;
}

.FileCombinationPopup_button--no:hover {
    background: #5a6268;
}

.FileCombinationPopup_button--yes {
    background: #007bff;
    color: white;
}

.FileCombinationPopup_button--yes:hover {
    background: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/FileCombinationPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".FileCombinationPopup_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.FileCombinationPopup {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    width: 480px;\n    max-width: 90%;\n    overflow: hidden;\n}\n\n.FileCombinationPopup_header {\n    background: #f8f9fa;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e9ecef;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.FileCombinationPopup_title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.FileCombinationPopup_close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #666;\n    cursor: pointer;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.FileCombinationPopup_close:hover {\n    background-color: #e9ecef;\n}\n\n.FileCombinationPopup_content {\n    padding: 24px 20px;\n}\n\n.FileCombinationPopup_question {\n    font-size: 16px;\n    color: #333;\n    margin-bottom: 16px;\n    line-height: 1.5;\n}\n\n.FileCombinationPopup_description {\n    font-size: 14px;\n    color: #666;\n    line-height: 1.6;\n    background: #f8f9fa;\n    padding: 12px;\n    border-radius: 4px;\n    border-left: 4px solid #007bff;\n}\n\n.FileCombinationPopup_buttons {\n    padding: 16px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n}\n\n.FileCombinationPopup_button {\n    padding: 8px 20px;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    min-width: 80px;\n}\n\n.FileCombinationPopup_button--no {\n    background: #6c757d;\n    color: white;\n}\n\n.FileCombinationPopup_button--no:hover {\n    background: #5a6268;\n}\n\n.FileCombinationPopup_button--yes {\n    background: #007bff;\n    color: white;\n}\n\n.FileCombinationPopup_button--yes:hover {\n    background: #0056b3;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
